import { makeStyles } from '../../../styles';
import { alpha } from '@mui/material';
export const useIconButtonStyles = makeStyles((theme) => ({
    default: {
        border: '1px solid transparent',
        borderRadius: theme.spacing(1),
        '& .material-icons': {
            fontSize: 20,
        },
    },
    'IconButton-text': (props) => {
        var _a;
        const color = props.color
            ? (_a = theme.palette[props.color]) === null || _a === void 0 ? void 0 : _a.main
            : theme.colors.text[900];
        return {
            color,
        };
    },
    'IconButton-outlined': (props) => {
        var _a;
        const color = props.color
            ? ((_a = theme.palette[props.color]) === null || _a === void 0 ? void 0 : _a.main) || theme.colors.gray[200]
            : theme.colors.text[900];
        return {
            border: `1px solid ${color}`,
            color,
            '&:disabled': {
                borderColor: alpha('#000', 0.26),
            },
        };
    },
    'IconButton-contained': (props) => {
        var _a, _b;
        const color = props.color
            ? ((_a = theme.palette[props.color]) === null || _a === void 0 ? void 0 : _a.main) || theme.colors.primary.main
            : theme.colors.gray[300];
        const hovered = props.color
            ? ((_b = theme.palette[props.color]) === null || _b === void 0 ? void 0 : _b.dark) || theme.colors.primary.dark
            : theme.colors.gray[100];
        return {
            backgroundColor: color,
            color: 'white',
            '&:hover': {
                backgroundColor: hovered,
                color: theme.palette.getContrastText(hovered),
            },
            '&:disabled': {
                color: theme.palette.getContrastText(alpha('#000', 0.12)),
                backgroundColor: alpha('#000', 0.12),
            },
        };
    },
}));
//# sourceMappingURL=IconButton.styles.js.map